import React, { Component } from "react";
import Banner from "./banner";
import OneSolution from "./oneSolution";
import GreatData from "./greatData";
import EventsReviewed from "./eventsReviewed";
import WhoAreWe from "./whoAreWe";
import VisibilitySensor from "react-visibility-sensor";

class Home extends Component {
  state = {
    name: ""
  };

  render() {
    return (
      <div>
        <Banner />
        <OneSolution />
        <GreatData />
        <VisibilitySensor minTopValue={-10}>
          {({ isVisible }) => {
            return (
              <>
                <EventsReviewed isVisible={isVisible} />
                <WhoAreWe isVisible={isVisible} />
              </>
            );
          }}
        </VisibilitySensor>
      </div>
    );
  }
}

export default Home;
